import { render, staticRenderFns } from "./AssociateLabExam.html?vue&type=template&id=73730c6f&external"
import script from "./AssociateLabExam.vue?vue&type=script&lang=js"
export * from "./AssociateLabExam.vue?vue&type=script&lang=js"
import style0 from "./AssociateLabExam.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports